import { throttle } from "./help-functions";

export default function () {
  const header = document.querySelector(".header");
  const sections = [...document.querySelectorAll('[section-shade]')];

  const darkClass = 'header-blue',
    lightClass = 'header-white',
    transparentClass = 'header-transparent';
  let lastColor = null, currentColor = null;

  const throttledHeaderChange = throttle(() => {
    const fromTop = window.scrollY;

    sections.forEach(section => {
      if (section.getAttribute('section-shade') == lastColor) return

      if (section.offsetTop - header.clientHeight <= fromTop &&
        section.offsetTop + section.offsetHeight - header.clientHeight > fromTop) {

        currentColor = section.getAttribute('section-shade');

        switch (currentColor) {
          case 'dark':
            header.classList.remove(lightClass, transparentClass);
            header.classList.add(darkClass)
            break;
          case 'light':
            header.classList.remove(darkClass, transparentClass);
            header.classList.add(lightClass)
            break;

          default:
            header.classList.remove(darkClass, lightClass);
            header.classList.add(transparentClass)
            break;
        }

        lastColor = currentColor;
      }
    });
  }, 500);


  window.addEventListener('scroll', throttledHeaderChange);
}